(function() {
  var History, store;
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  store = window.Store || (window.Store = {});
  store.app = store.app || (store.app = {});
  History = window.History;
  store.Main = {
    init: function() {
      this.appModel = new store.Models.AppModel();
      this.pageLoaded();
      History.Adapter.bind(window, 'statechange', __bind(function(e) {
        return this.stateChange(e);
      }, this));
    },
    internalLinkClicked: function() {
      var path, title;
      title = 'Theme &mdash;&nbsp;' + $(this).attr('title') || '';
      path = $(this).attr('href');
      History.pushState({
        path: path,
        title: title
      }, title, path);
      return false;
    },
    pageLoaded: function() {
      var node, _i, _len, _ref;
      _ref = $('.extend');
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        node = _ref[_i];
        this.initView(node);
      }
    },
    initView: function(node) {
      var view, viewName;
      viewName = $(node).attr('data-view');
      if (viewName && store.Views[viewName]) {
        view = new store.Views[viewName]({
          el: node,
          appModel: this.appModel
        });
        $(node).removeClass('extend');
      }
    },
    stateChange: function(e) {
      var State, page;
      this.appModel.trigger('state-change');
      State = History.getState();
      console.log(State);
      page = State.data.path;
      $('#content').load(page + ' div#content', __bind(function(data) {
        return this.pageLoaded();
      }, this));
    }
  };
}).call(this);
